import React from 'react';

import styled from 'styled-components';
import { Required, Text } from 'components';

interface LabelProps {
  label: string;
  required?: boolean;
}

const Label: React.FC<LabelProps> = ({ label, required }) => (
  <Container>
    <LabelText>{label}</LabelText>
    {required && (
      <>
        <span>&nbsp;</span>
        <Required />
      </>
    )}
  </Container>
);

export default React.memo(Label);

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const LabelText = styled(Text).attrs({ strong: true })`
  margin-bottom: 2px;
`;
